import { html, type Html, Page } from 'rune-ts';
import { MyMembershipTabData } from '../S/type';
import { MembershipUtilS } from '../../../../../../services/MarppleShop/features/Membership/outbound/share';
import { navigateTo } from '../../../../../../services/MarppleShop/shared/app/util';
import {
  makeEmptyScreenNavigate,
  makeSubScreenNavigate,
} from '../../../../../../services/MarppleShop/shared/app/navigate';
import { MyPageMembershipWidget } from '@marpple/mco-membership-ui';
import { EXCLUDE_MAKER_MODULE } from '../../../../../../services/MarppleShop/shared/constant';
import klass from './MyMembershipList.module.scss';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF';
import { my_membership_detail_path } from '../../../../../../services/MarppleShop/features/Membership/constant';
import { MembershipErrorEnable } from '../../../../../../services/MarppleShop/features/Membership/error/error_enable';
import { ConfigSentryF } from '../../../../../Config/Sentry/F/Function/module/ConfigSentryF';
import { Alert } from '../../../../../../services/MarppleShop/shared/components/cells/Alert/Alert';
import { not_existing_project_store_message } from '../../../../../../services/MarppleShop/features/Membership/constant/message';
import { getActivatedSdkWithEvent } from '../../../../../../services/MarppleShop/features/Membership/util';

export class MyMembershipList extends Page<MyMembershipTabData> {
  private _membershipErrorEnable = new MembershipErrorEnable(this);

  get isMobile(): boolean {
    return this.data.layout_options.is_mobile;
  }

  get isApp(): boolean {
    return MShopUtilF.isApp();
  }

  override async onRender() {
    try {
      const client = await getActivatedSdkWithEvent(this.data.membership_token);
      const widget = new MyPageMembershipWidget({
        client,
        isMobile: this.isMobile,
        isApp: this.isApp,
        toggleSpinner: MembershipUtilS.toggleSpinner,
        onCreatorShopButtonClick: this.onCreatorShopButtonClick.bind(this),
        onReJoinMembershipButtonClick: this.onReJoinMembershipButtonClick.bind(this),
        onSeeMembershipDetailButtonClick: this.onSeeMembershipDetailButtonClick.bind(this),
        onError: this._membershipErrorEnable.onError,
        onScrollLock: MShopUtilF.bodyFixed$,
        onShopButtonClick: this._onShopButtonClick.bind(this),
      });

      widget.render(this.element());
    } catch (e) {
      ConfigSentryF.error(e);
      await this._membershipErrorEnable.openWidgetRenderErrorModal();
    }
  }

  private _onShopButtonClick(shopUrl: string) {
    navigateTo(shopUrl, makeEmptyScreenNavigate);
  }

  // 크리에이터 샵 버튼 클릭 시 콜백
  async onCreatorShopButtonClick(projectId: string) {
    const domain_name = this.getDomainName(projectId);
    if (!domain_name) {
      ConfigSentryF.error(`projectId=${projectId} 의 domain_name이 존재하지 않습니다.`);
      await Alert.open({ title: not_existing_project_store_message });
    }

    navigateTo(`/${ET.lang}/${domain_name}`, makeEmptyScreenNavigate);
  }

  // 멤버십 상세보기 버튼 클릭 시 콜백
  onSeeMembershipDetailButtonClick(membershipId: string): void {
    navigateTo(`/${ET.lang}/@/${my_membership_detail_path}/${membershipId}`, makeSubScreenNavigate);
  }

  // 멤버십 재가입 버튼 클릭 시 콜백
  async onReJoinMembershipButtonClick(projectId: string, membershipId: string) {
    const domain_name = this.getDomainName(projectId);
    if (!domain_name) {
      ConfigSentryF.error(`projectId=${projectId} 의 domain_name이 존재하지 않습니다.`);
      await Alert.open({ title: not_existing_project_store_message });
    }

    navigateTo(
      `/${ET.lang}/${domain_name}/membership/payment?membership_id=${membershipId}`,
      makeSubScreenNavigate,
    );
  }

  protected override template(): Html {
    return html` <div class="${klass.root} ${EXCLUDE_MAKER_MODULE}"></div>`;
  }

  private getDomainName(projectId: string): string {
    return this.data.project_domain_name_map[projectId] || '';
  }
}
